export default __webpack_public_path__ + "static/media/ReBuyLogoTrans.b38c320d.png";